export default __webpack_public_path__ + "cdcbd6d4c19362926bdab37708324492.png";